import gsap from 'gsap';


function Menu() {
  
  var elMenu = document.querySelector('.mobile_menu_content');
  var elPreview = elMenu.querySelector('.js-menu-preview');
  
  // console.log(`MENU`, elMenu);

  const aMenus = elMenu.querySelectorAll('.menu-item');
  const nbMenus = aMenus.length;
  for(let i = 0; i < nbMenus; ++i) {
    let elMenuItem = aMenus[i];
    elMenuItem.addEventListener('mouseover', onMenuOver);
  }
  
  function onMenuOver(evt) {
    const id = evt.target.parentNode.dataset.menuId;
    // console.log(`over id ${id}`, elPreview.querySelectorAll(`[data-menu-id='${id}']`));
    
    let elMenuItem, els;
    for(let i = 0; i < nbMenus; ++i) {
      elMenuItem = aMenus[i];
      els = elPreview.querySelectorAll(
        `[data-menu-id='${elMenuItem.dataset.menuId}']`
      );
      gsap.to(els, {
        autoAlpha: elMenuItem.dataset.menuId === id ? 1 : 0
      }); 
    }
  }
}

export default Menu;
